//@ts-nocheck

import { useCallback } from "react";


export default function useGtagPageview() {
    return useCallback((page?: string) => {
        if (window.gtag) {
            window.gtag('config', 'UA-169898346-1', {
                anonymize_ip: true,
                page_path: page || window.location.pathname
            });
        }
    }, [])
}
